import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Sandbox14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.75 5V1H6.25V5H5L5.3125 6.25H2.21353L3.46353 3.75H5V2.25H3.30902C2.83555 2.25 2.40272 2.5175 2.19098 2.94098L0.381966 6.55902C0.295181 6.73259 0.25 6.92398 0.25 7.11803V10.5C0.25 11.1904 0.809645 11.75 1.5 11.75H12.5C13.1904 11.75 13.75 11.1904 13.75 10.5V7.11803C13.75 6.92398 13.7048 6.73259 13.618 6.55902L11.809 2.94098C11.5973 2.5175 11.1644 2.25 10.691 2.25H9V3.75H10.5365L11.7865 6.25H8.6875L9 5H7.75ZM12.25 7.75H1.75V10.25H12.25V7.75Z'
      fill='currentColor'
    />
  </Svg>
);

Sandbox14.displayName = 'Sandbox14';
export default Sandbox14;
